import { Injectable } from '@angular/core';
import { CoreService } from '../core/core.service';
import { HttpClient, HttpRequest, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Response } from '@angular/http';
import { Observable } from 'rxjs';
import { Body } from '@angular/http/src/body';
import { pgiAuthors } from 'src/app/models/authors';
import { simpleAuthor } from 'src/app/models/simpleauthor';
import { PgiNotesAuthor } from 'src/app/models/pgiNotesAuthor';
import { CalcHeaders } from 'src/app/models/calcHeader';

@Injectable({
  providedIn: 'root'
})
export class AuthorsService {
  setData: simpleAuthor;
  constructor(private coreService: CoreService, private http: HttpClient) { }

  getAuthors(): Observable<pgiAuthors[]> {
    return  this.http.get<pgiAuthors[]>(this.coreService.appRoot + '/api/authors');

  }

  getAuthorsList(): Observable<pgiAuthors[]> {
    return  this.http.get<pgiAuthors[]>(this.coreService.appRoot + '/api/authorsList');

  }

  getAuthorByName(name, data1, data2): Observable<pgiAuthors[]> {
    this.setData = { nazwa: name, data1: data1, data2: data2};
    console.log(this.coreService.appRoot + '/api/author/' + this.setData);
    return  this.http.post<pgiAuthors[]>(this.coreService.appRoot + '/api/author' , this.setData);
  }

  updateAuthor(auth): Observable<pgiAuthors> {
    return this.http.put<pgiAuthors>(this.coreService.appRoot + '/api/update' ,  auth);
  }

  addAuthors(auth): Observable<pgiAuthors[]> {
    return this.http.put<pgiAuthors[]>(this.coreService.appRoot + '/api/addAllAuthors' ,  auth);
  }

  getNotes(): Observable<PgiNotesAuthor> {
    return  this.http.get<PgiNotesAuthor>(this.coreService.appRoot + '/api/notes');

  }

  addNotesForAll(notes): Observable<PgiNotesAuthor> {
    return this.http.put<PgiNotesAuthor>(this.coreService.appRoot + '/api/updateNotes' ,  notes);
  }

  getNotesForAuthor(): Observable<string> {
    return this.http.get<string>(this.coreService.appRoot + '/api/notesAuthor');
  }

  updateAuthors(authors): Observable<pgiAuthors[]> {
    return this.http.put<pgiAuthors[]>(this.coreService.appRoot + '/api/updateAuthors' ,  authors);
  }

  getAuthorByUserId(id): Observable<pgiAuthors> {
    return this.http.get<pgiAuthors>(this.coreService.appRoot + '/api/getAuthorByUserId/' + id);
  }

  clearAccountBalance(header): Observable<CalcHeaders> {
    return this.http.post<CalcHeaders>(this.coreService.appRoot + '/api/clearAccountBalance',  header);
  }
  clearAllAccountBalance(): Observable<pgiAuthors> {
    return this.http.get<pgiAuthors>(this.coreService.appRoot + '/api/clearAllAccountBalance');
  }
}
